<template>
  <div class="mon-analyse">
    <FormApat v-if="showClientUI" />

    <div v-else-if="!roleChecked" class="mon-analyse__state" role="status" aria-live="polite">
      <span class="mon-analyse__spinner" aria-hidden="true" />
      <p class="mon-analyse__state-text">Ouverture de votre questionnaire…</p>
    </div>

    <div v-else class="client-page">
      <div class="client-card client-empty">
        <span class="client-empty__icon" aria-hidden="true">
          <LockClosedIcon />
        </span>
        <h1 class="client-empty__title">Questionnaire réservé aux clients</h1>
        <p class="client-empty__text">
          Le questionnaire patrimonial n’est accessible qu’avec un compte client.
          Votre compte donne accès aux espaces de suivi et de validation des dossiers.
        </p>
        <router-link to="/analyse-patrimoniale/dashboards" class="client-btn client-btn--primary">
          Retour au tableau de bord
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { LockClosedIcon } from '@heroicons/vue/24/outline';
import FormApat from './FormApat.vue';
import { getUserRole, isClientFacingRole } from '@/utils/auth';
import { syncEmployeProfileFromApi } from '@/utils/permissions';

/**
 * Le rôle est relu après synchronisation serveur : sans cela, un client dont la
 * session vient d'être restaurée voyait le message « réservé aux clients ».
 */
const userRole = ref(getUserRole() || '');
/** Passe à `true` une fois le profil serveur confirmé. */
const roleChecked = ref(false);

const showClientUI = computed(() => isClientFacingRole(userRole.value));

onMounted(async () => {
  await syncEmployeProfileFromApi();
  userRole.value = getUserRole() || '';
  roleChecked.value = true;
});
</script>

<style scoped>
.mon-analyse__state {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-6);
}

.mon-analyse__state-text {
  font-family: var(--font-body);
  color: var(--client-text-muted, #6b6155);
  margin: 0;
}

.mon-analyse__spinner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--client-line, rgba(84, 57, 41, 0.1));
  border-top-color: var(--brand-gold);
  animation: mon-analyse-spin 0.7s linear infinite;
}

@keyframes mon-analyse-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .mon-analyse__spinner {
    animation: none;
  }
}
</style>
